<template>
    <footer :aria-label="$t('footer')">
        <div id="footer" class="row">
            <div class="col-9 col-sm-10 footer-info mb-5 py-5 px-3" v-if="$route.name.includes('home')">
                <h3 class="settings-btn d-flex justify-content-center align-items-center m-0 text-center" data-aos="show-from-bottom" data-aos-easing="from-bottom-easing" v-b-modal.settings-modal>
                    <img class="settings-icon me-3" src="@/assets/images/setting-purple@2x.png" width="37" alt="">
                    {{$t('settings.experience-settings')}}
                </h3>
            </div>
            <div class="col-12 footer-info mb-2 mt-2" v-if="!$route.name.includes('home')">
                <h4 data-aos="show-from-bottom" data-aos-easing="from-bottom-easing" class="text-center align-self-center m-0">
                    {{ $t('continue-study') }}
                </h4>
            </div>
            <div class="col-11 categories-choice mb-5" v-if="!$route.name.includes('home')">
                <div class="row p-0 m-0 d-flex justify-content-center">
                    <div
                        v-for="(category, i) in categories"
                        v-bind:key="category.name"
                        class="category col-12 col-sm-6"
                        :class="[category.name, $route.name.includes(category.name) ? 'active' : null]"
                        @click="redirection(category.name)"
                        :style="'--category-color:' + category.color"
                        data-aos="show-from-bottom"
                        data-aos-anchor=".footer-info"
                        data-aos-easing="from-bottom-easing"
                        :data-aos-delay="i * 100"
                    >
                    <div class="category-text col-11 pe-0 pe-sm-1">
                        <h3 class="p-0 m-0">
                            {{ category.text }}
                        </h3>
                    </div>
                    <div class="chevron-right col-1 text-end d-flex align-items-center">
                        <font-awesome-icon :icon="['fas', 'chevron-right']" />
                    </div>
                    </div>
                </div>

            </div>
            <div class="col-12 footer-info mb-5">
                <router-link :to="{ name: `bankofcanadamuseum:${$i18n.locale}` }" target="_blank">
                    <img
                        data-aos="show-from-bottom"
                        data-aos-easing="from-bottom-easing"
                        data-aos-anchor=".footer-info"
                        data-aos-offset="50"
                        data-aos-delay="400"
                        class="boc-logo"
                        :src="require(`@/assets/images/${$i18n.locale === 'en' ? 'BoCM' : 'MBoC'}_Small_White@2x.png`)" :alt="$t('logo-boc')"
                    >
                </router-link>
            </div>
        </div>
    </footer>
</template>

<script>
// Import helpers
import { Default }  from '@/helpers/Default.js';

export default {
    data () {
        return {
            animationActive: Default.animationsToggle,
            categories:      [
                { name: 'pib',         text: this.$i18n.t('gross-domestic'),       color: Default.categories.pib.color         },
                { name: 'immigration', text: this.$i18n.t('human-resource') ,      color: Default.categories.immigration.color },
                { name: 'analyse',     text: this.$i18n.t('foreign-investment'),   color: Default.categories.analyse.color     },
                { name: 'exchange',    text: this.$i18n.t('commercial-exchanges'), color: Default.categories.exchange.color    }
            ]
        };
    },
    methods: {
        /**
         * Redirection to a category
         *
         * @param    {string}    to     the category route name
         */
        redirection (to) {
            this.$router.push({ name: `${to}:${this.$i18n.locale}` });
        }
    }
}
</script>
